import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { ClickOutsideModule } from 'ng-click-outside';

import { AutocompleteModule } from './components/autocomplete/autocomplete.module';
import { PipeModule } from 'app/shared/pipes/pipe.module';

import {NgxPaginationModule} from 'ngx-pagination'; 

//COMPONENTS
import { FooterComponent } from "./footer/footer.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { HorizontalMenuComponent } from './horizontal-menu/horizontal-menu.component';
import { VerticalMenuComponent } from "./vertical-menu/vertical-menu.component";
import { CustomizerComponent } from './customizer/customizer.component';
import { NotificationSidebarComponent } from './notification-sidebar/notification-sidebar.component';

//DIRECTIVES
import { ToggleFullscreenDirective } from "./directives/toggle-fullscreen.directive";
import { SidebarLinkDirective } from './directives/sidebar-link.directive';
import { SidebarDropdownDirective } from './directives/sidebar-dropdown.directive';
import { SidebarAnchorToggleDirective } from './directives/sidebar-anchor-toggle.directive';
import { SidebarDirective } from './directives/sidebar.directive';
import { TopMenuDirective } from './directives/topmenu.directive';
import { TopMenuLinkDirective } from './directives/topmenu-link.directive';
import { TopMenuDropdownDirective } from './directives/topmenu-dropdown.directive';
import { TopMenuAnchorToggleDirective } from './directives/topmenu-anchor-toggle.directive';

//SYNFUNCTION
import { DatePickerModule, DateTimePickerModule, TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { CheckBoxModule, ButtonModule, SwitchModule, RadioButtonModule } from '@syncfusion/ej2-angular-buttons';

import { FileManagerAllModule } from '@syncfusion/ej2-angular-filemanager';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { MultiSelectAllModule, DropDownListModule,ComboBoxModule } from '@syncfusion/ej2-angular-dropdowns';
import { UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { DropDownButtonModule, SplitButtonModule, ProgressButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { TreeGridAllModule } from '@syncfusion/ej2-angular-treegrid';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { ToolbarModule, TreeViewModule, ContextMenuModule, TabAllModule } from '@syncfusion/ej2-angular-navigations';
import { ToastModule } from '@syncfusion/ej2-angular-notifications';

import { ListViewAllModule } from '@syncfusion/ej2-angular-lists';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { MaskedTextBoxModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';

//COMPONENTS HAN
import { danhmucchungeditComponent } from "./components/danhmuc/danhmucchungedit.component";



@NgModule({
    exports: [
        CommonModule,
        FooterComponent,
        NavbarComponent,
        VerticalMenuComponent,
        HorizontalMenuComponent,
        CustomizerComponent,
        NotificationSidebarComponent,
        ToggleFullscreenDirective,
        SidebarDirective,
        TopMenuDirective,
        NgbModule,
        TranslateModule,
        NgxPaginationModule,

      //synfu
        DatePickerModule,
        DateTimePickerModule,
        TimePickerModule,
        CheckBoxModule,
        ButtonModule,
        SwitchModule,
        RadioButtonModule,
        GridAllModule,
        FileManagerAllModule,
    MultiSelectAllModule,
    ToastModule,
        ComboBoxModule,
        DropDownListModule,
        UploaderModule,
        DropDownButtonModule,
        SplitButtonModule,
        ProgressButtonModule,
        TreeGridAllModule,
        RichTextEditorAllModule,
        ToolbarModule,
        TreeViewModule,
        ContextMenuModule,
        TabAllModule,
        DialogModule,
        MaskedTextBoxModule,
        NumericTextBoxModule,

        //COMPONENT
        danhmucchungeditComponent,
    ],
    imports: [
        RouterModule,
        CommonModule,
        NgbModule,
        TranslateModule,
        FormsModule,
        OverlayModule,
        ReactiveFormsModule ,
        PerfectScrollbarModule,
        ClickOutsideModule,
        AutocompleteModule,
        PipeModule,
        NgxPaginationModule,

        //synfu
        DatePickerModule,
        DateTimePickerModule,
        TimePickerModule,
        CheckBoxModule,
        ButtonModule,
        SwitchModule,
        RadioButtonModule,
        GridAllModule,
        FileManagerAllModule,
      MultiSelectAllModule,
      ToastModule,
        DropDownListModule,
        ComboBoxModule,
        UploaderModule,
        DropDownButtonModule,
        SplitButtonModule,
        ProgressButtonModule,
        TreeGridAllModule,
        RichTextEditorAllModule,
        ToolbarModule,
        TreeViewModule,
        ContextMenuModule,
        TabAllModule,
        DialogModule,
        MaskedTextBoxModule,
        NumericTextBoxModule,


    ],
    declarations: [
        FooterComponent,
        NavbarComponent,
        VerticalMenuComponent,
        HorizontalMenuComponent,
        CustomizerComponent,
        NotificationSidebarComponent,
        ToggleFullscreenDirective,
        SidebarLinkDirective,
        SidebarDropdownDirective,
        SidebarAnchorToggleDirective,
        SidebarDirective,
        TopMenuLinkDirective,
        TopMenuDropdownDirective,
        TopMenuAnchorToggleDirective,
        TopMenuDirective,

        //COMPONENT
        danhmucchungeditComponent,

    ]
})
export class SharedModule { }
